import { definePartner } from "../definePartner";

/**
 * EasyRewardz: lists offers but has no offer apply; its typed codes are checked with an OTP (`requestId`) through `/coupon/redeem` (the port's `redeemCode`).
 *
 * The app has no conversation of its own with it yet: every conversation field is the baseline's,
 * exactly as before it had a folder (R2.2 changed no behaviour). A gap between what the backend
 * offers and what the app does is asked when R2.4 builds the partner steps (DISCOUNT_V2_PLAN.md §9.12).
 */
export default definePartner("easyrewardz", {
  name: "EasyRewardz",
  backend: {
    listsOffers: true,
    appliesOffers: false,
    applyOtp: "none",
    takesTypedCodes: true,
    releaseNeeds: ["couponCode", "requestId"],
    exercisedAtSave: false,
  },
  // The backend defines `refundLoyaltyPoints` for it (points-conversations.md §2).
  refundsPoints: true,
  // A typed code is redeemed with the customer's OTP (`coupon/redeem`; old FE ItemEditController.js 1375-1440); the coupon is blocked meanwhile, so a wrong OTP releases it (1563-1590), and the prompt has Resend (`coupon/resend`, `api_easyrewardz_service.js` 800-880).
  codeNeedsOtp: true,
  releasesCouponOnWrongOtp: true,
  resendsCodeOtp: true,
});
